import { Component, Injector, OnInit, } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { ApAlertService, ApNotificationService } from 'webcommon/core-ui';
import { FcGenericListItemDto, FcModifyGenericListItemDto } from 'webcommon/shared';
import { FindControlRepository } from 'webcommon/webapi';
import { FcItemModalMode } from '../../../models/FcItemModalContext';
import { FcItemModalBaseComponent } from '../../generic/fc-item-modal-base.component';

@Component({
  providers: [ ApAlertService, ],
  selector: 'fc-generic-list-modal',
  templateUrl: './fc-generic-list-modal.component.html',
})
export class FcGenericListModalComponent extends FcItemModalBaseComponent implements OnInit {

  constructor(
    elementInjector: Injector,
    public override apNotificationService: ApNotificationService,
    public override alertService: ApAlertService,
    private findControlRepository: FindControlRepository,
  ) {
    super(elementInjector, apNotificationService, alertService);
  }
  baseId = 'fc-item';
  fcItemModalModeEnum = FcItemModalMode;
  genericListItem: FcGenericListItemDto;

  override ngOnInit() {
    super.ngOnInit();

    this.fcItemFormGroup.addControl('genericList', new UntypedFormGroup({}));
    if (this.fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.isLoading = true;
      this.findControlRepository.getItem(this.fcModalItemContext.findControlId, this.fcModalItemContext.selectedFindItemPk).pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        takeUntil(this.onDestroy$)
      ).subscribe((data) => {
        this.genericListItem = data;
      },
      (error: unknown) => {
        this.alertService.error('Error loading ' + this.fcModalItemContext.findControlName + '.');
        throw error;
      });
    } else {
      this.genericListItem = {
        Id: '',
        Name: '',
        Inactive: false,
        UserDefined: true,
      };
    }
  }
  save() {
    this.alertService.clearAllAlerts();
    if (this.fcItemFormGroup.invalid) {
      return;
    }
    this.isSaving = true;
    const rawForm = this.fcItemFormGroup.getRawValue();
    const modifyItemDto: FcModifyGenericListItemDto = {
      ExternalId: rawForm.genericList.externalIdControl,
      Name: rawForm.genericList.nameControl,
      Inactive: rawForm.genericList.inactiveControl,
      Notes: rawForm.genericList.notesControl,
      UserDefined: rawForm.genericList.userDefinedControl,
    };
    if (this.fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.findControlRepository.updateItem(this.fcModalItemContext.findControlId, this.genericListItem.Id, modifyItemDto).pipe(
        finalize(() => {
          this.isSaving = false;
        }),
        takeUntil(this.onDestroy$)
      ).subscribe((data) => {
        this.onClose(data);
      },
      (error: unknown) => {
        this.apNotificationService.displayStandardError();
        throw error;
      });
    } else {
      this.findControlRepository.createItem(this.fcModalItemContext.findControlId, modifyItemDto).pipe(
        finalize(() => {
          this.isSaving = false;
        }),
        takeUntil(this.onDestroy$)
      ).subscribe((data) => {
        this.onClose(data);
      },
      (error: unknown) => {
        this.apNotificationService.displayStandardError();
        throw error;
      });
    }
  }
}
